import React, { useState, useEffect } from "react";
import { Button, Modal, Card, Form, Row, Col } from "react-bootstrap";
import { CASH, CHEQUE } from "../constants";
import AgGridTable from "../Tables/agGridTable";
import DataTable from "../Tables/DataTable";

const PaymentDetails = (props) => {
  const { data, closeModal  } = props;
  console.log(data)
  const [show, setShow] = useState(props.show);
  const [transactionInfo, setTransactionInfo] = useState([]);
  const [headerInfo, setHeaderInfo] = useState([]);
  const [nestedHeaderInfo, setNestedHeaderInfo] = useState([]);
  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  useEffect(() => {
    let headerList = [
        {
          name: "Payment Mode",
          key: "payMode",
        },
        { name: "Transaction Id", key: "ORDER_ID" },
        {
            name: "Currency",
            key: "Guardian",
            requiredActions: [
              {
                name: "Father",
                dataKey: "twoThousand",
              },
              {
                name: "Father",
                dataKey: "twoThousand",
              },
              {
                name: "Mother",
                dataKey: "twoThousand",
              },
              {
                name: "Mother",
                dataKey: "twoThousand",
              },
            ],
        }
      ];
      
     
  }, [data])
  
  const handleClose = () => {
    setShow(false);
    closeModal();
  };
  const handleShow = () => setShow(true);
  
  return (
    <>
      <Modal show={show} size="xl" onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Payment Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        {/* <Card>
            <Card.Header> Transaction Details </Card.Header>
            <Card.Body> */}
                {/* <DataTable
                header={data.tableHeaders}
                data={data.tableData}
                nestedHeader={data.nestedHeaders}
                /> */}
                <AgGridTable 
            rowData={data.tableData} 
            columnDefs={data.tableHeaders} 
            defaultColDef={{
              resizable: true,minWidth: 100}}
              />
            {/* </Card.Body>
          </Card> */}
        </Modal.Body>
        <Modal.Footer>
          
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PaymentDetails;
